module.exports = __webpack_public_path__ + "img/zoom-in.0e546a8a.svg";